import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import {
  SiApplemusic,
  SiSpotify,
  SiTiktok,
  SiYoutube,
  SiInstagram,
  SiX,
} from "react-icons/si";
import { MdEmail } from "react-icons/md";
import { TfiFacebook } from "react-icons/tfi";
import { IoShareSocial } from "react-icons/io5";
import { GiHamburgerMenu } from "react-icons/gi";

const Header = () => {
  const [showSocialMenu, setShowSocialMenu] = useState(false);
  const [showNavMenu, setShowNavMenu] = useState(false);

  const toggleSocialMenu = () => setShowSocialMenu(!showSocialMenu);
  const toggleNavMenu = () => setShowNavMenu(!showNavMenu);

  const closeMenus = () => {
    setShowNavMenu(false);
    setShowSocialMenu(false);
  };

  const neonColors = [
    "#ff00ff",
    "#00ffff",
    "#39ff14",
    "#ff3131",
    "#fff01f",
    "#ff5f1f",
    "#bc13fe",
    "#ff1493",
  ];

  const randomNeon = (e) => {
    const randomColor =
      neonColors[Math.floor(Math.random() * neonColors.length)];

    e.currentTarget.style.color = randomColor;
    e.currentTarget.style.filter = `drop-shadow(0 0 8px ${randomColor})`;
  };

  const resetColor = (e) => {
    e.currentTarget.style.color = "";
    e.currentTarget.style.filter = "";
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="logo ">
          <Link to="/" onClick={closeMenus}>
            <img src={Logo} alt="Dyed To Self" className="navbar-logo" />
          </Link>
        </div>



        {/* <ul className={`main-nav ${showNavMenu ? "active" : ""}`}>
          <li>
            <NavLink to="/" onClick={closeMenus}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/news" onClick={closeMenus}>
              News
            </NavLink>
          </li>           
          <li>
            <NavLink to="/about" onClick={closeMenus}>
              About
            </NavLink>
          </li>
        </ul> */}



        <ul className={`social-links ${showSocialMenu ? "active" : ""}`}>
          <li>
            <a
              href="https://www.facebook.com/DyedToSelf"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              onMouseEnter={randomNeon}
              onMouseLeave={resetColor}
            >
              <TfiFacebook />
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/DyedToSelf"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              onMouseEnter={randomNeon}
              onMouseLeave={resetColor}
            >
              <SiInstagram />
            </a>
          </li>
          <li>
            <a
              href="https://www.x.com/DyedToSelf"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X"
              onMouseEnter={randomNeon}
              onMouseLeave={resetColor}
            >
              <SiX />
            </a>
          </li>
          <li>
            <a
              href="https://www.tiktok.com/@DyedToSelf"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
              onMouseEnter={randomNeon}
              onMouseLeave={resetColor}
            >
              <SiTiktok />
            </a>
          </li>
          <li>
            <a
              href="https://www.youtube.com/@DyedToSelf"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              onMouseEnter={randomNeon}
              onMouseLeave={resetColor}
            >
              <SiYoutube />
            </a>
          </li>


          <li>
            <a href="mailto:hello@dyedtoself.com" aria-label="Email"
              onMouseEnter={randomNeon}
              onMouseLeave={resetColor}>
              <MdEmail />
            </a>
          </li>
        </ul>
      </div>

      <div className="menu-toggles">
        {/* <button
          type="button"
          className="hamburger nav-toggle"
          onClick={toggleNavMenu}
          aria-label="Toggle navigation menu"
        >
          <GiHamburgerMenu />
        </button> */}

        <button
          type="button"
          className="hamburger social-toggle"
          onClick={toggleSocialMenu}
          aria-label="Toggle social menu"
          onMouseEnter={randomNeon}
          onMouseLeave={resetColor}
        >
          <IoShareSocial />
        </button>
      </div>
    </nav>
  );
};

export default Header;